import { Fragment, h, ComponentChildren } from "preact"
import { useErrorBoundary } from "preact/hooks"
import { logger } from "@nosto/search-js/utils"

/**
 * Error boundary component to log UI level errors
 * @group Components
 */
export default function ErrorBoundary({ children }: { children: ComponentChildren }) {
    const [error] = useErrorBoundary()

    if (error) {
        logger.error("Error caught in ErrorBoundary", error)
    }

    return <Fragment>{children}</Fragment>
}
